<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
             <a-form-item :label="$t('label.farms')">
              <j-dict-select-tag :placeholder="$t('label.pleaseSelectFarms')" v-model="queryParam.farmCode" dictCode="sys_depart,depart_name,org_code,org_category='5' and del_flag='0'"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.feedingLot')">
              <j-dict-select-tag :placeholder="$t('label.pleaseSelectTheFeedingLot')" v-model="queryParam.breedBatchCode" dictCode="efs_md_breed_batch,name,code"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>

            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>
      <!--<a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a v-if="record.approvalStatus!='30'" @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider v-if="record.approvalStatus!='30'" type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{$t('button.details')}}</a>
              </a-menu-item>
             <!-- <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{$t('button.delete')}}</a>
                </a-popconfirm>
              </a-menu-item>-->
              <a-menu-item>
                <a-popconfirm :title="$t('tip.makeSureTheReviewIsApproved')" @confirm="() => handlePass(record.id)">
                  <a>{{$t('button.reviewApproved')}}</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                  <a-popconfirm :title="$t('tip.rejected')" @confirm="() => handleFailure(record.id)">
                 <a>{{$t('button.rejected')}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-stl-batch-settlement-modal ref="modalForm" @ok="modalFormOk"></efs-stl-batch-settlement-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsStlBatchSettlementModal from './modules/EfsStlBatchSettlementModal'
  import { putAction } from '@api/manage'

  export default {
    name: 'EfsStlBatchSettlementList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EfsStlBatchSettlementModal
    },
    data () {
      return {
        description: 'efs_stl_batch_settlement管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },

          {
            slotName: 'tableHeader.batch',
            scopedSlots: { title: 'tableHeader.batch'},
            align:"center",
            dataIndex: 'breedBatchCode_dictText'
          },
          {
            title:'批次名称',
            align:"center",
            dataIndex: 'breedBatchName'
          },
          {
            title:'批次创建日期',
            align:"center",
            dataIndex: 'batchCreateDate',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'品类',
            align:"center",
            dataIndex: 'breedVarietyCode_dictText'
          },
          {
            title:'养殖周期',
            align:"center",
            dataIndex: 'cycle'
          },
          {
            title:'进苗数量',
            align:"center",
            dataIndex: 'realImpQuantity'
          },
          {
            title:'进苗日龄',
            align:"center",
            dataIndex: 'realImpAge'
          },
          {
            slotName: 'tableHeader.grower',
            scopedSlots: { title: 'tableHeader.grower'},
            align:"center",
            dataIndex: 'farmerCode_dictText'
          },
          {
                        slotName: 'tableHeader.company',
            scopedSlots: { title: 'tableHeader.company'},
            align:"center",
            dataIndex: 'companyCode_dictText'
          },
          {
            title:'养户地址',
            align:"center",
            dataIndex: 'familyAddress'
          },
          {
            slotName: 'tableHeader.farms',
            align:"center",
            dataIndex: 'farmCode_dictText',
            scopedSlots: { title: 'tableHeader.farms'}
          },
          {
            title:'养殖场地址',
            align:"center",
            dataIndex: 'farmAddress'
          },
          {
            title:'养户电话',
            align:"center",
            dataIndex: 'farmerPhone'
          },
          {
            title:'结算金额',
            align:"center",
            dataIndex: 'settlementAmount'
          },
          {
            slotName: 'tableHeader.documentNo',
            align:"center",
            scopedSlots: {customRender: 'orderCode', title: 'tableHeader.documentNo'}
          },
          {
            slotName: 'tableHeader.stocker',
            scopedSlots: { title: 'tableHeader.stocker'},
            align:"center",
            dataIndex: 'managerCode_dictText'
          },
          {
            slotName: 'tableHeader.contracts',
            scopedSlots: { title: 'tableHeader.contracts'},
            align:"center",
            dataIndex: 'contractCode_dictText'
          },
          {
            title:'出栏数量',
            align:"center",
            dataIndex: 'outNumber'
          },
          {
            title:'日龄',
            align:"center",
            dataIndex: 'dayAge'
          },
          {
            title:'出栏均重',
            align:"center",
            dataIndex: 'aveWeight'
          },
          {
            title:'日增重',
            align:"center",
            dataIndex: 'addWeight'
          },
          {
            title:'料肉比',
            align:"center",
            dataIndex: 'mfRatio'
          },
          {
            title:'出栏率',
            align:"center",
            dataIndex: 'outRatio'
          },
          {
            title:'次品率',
            align:"center",
            dataIndex: 'badRatio'
          },
          {
            title:'禽苗成本',
            align:"center",
            dataIndex: 'chickCost'
          },
          {
            title:'饲料成本',
            align:"center",
            dataIndex: 'feedCost'
          },
          {
            title:'动保成本',
            align:"center",
            dataIndex: 'insuranceCost'
          },
          {
            title:'费用金额',
            align:"center",
            dataIndex: 'feeAmount'
          },
          {
            title:'奖励金额',
            align:"center",
            dataIndex: 'awardAmount'
          },
          {
            title:'补贴金额',
            align:"center",
            dataIndex: 'subsidyAmount'
          },
          {
            title:'处罚金额',
            align:"center",
            dataIndex: 'punishmentAmount'
          },
          {
            title:'托养费用',
            align:"center",
            dataIndex: 'fosterCareFee'
          },
          {
            title:'分红',
            align:"center",
            dataIndex: 'distributeDividends'
          },
          {
            title:'利润共享',
            align:"center",
            dataIndex: 'profitShare'
          },
          {
            title:'保证金',
            align:"center",
            dataIndex: 'bond'
          },
          {
            title:'扣减保证金',
            align:"center",
            dataIndex: 'substractBond'
          },
          {
            title:'结算保证金',
            align:"center",
            dataIndex: 'settlementBond'
          },
          {
            title:'已计提费用',
            align:"center",
            dataIndex: 'pedFee'
          },
          {
            title:'结算费用',
            align:"center",
            dataIndex: 'settlementFee'
          },
          {
            title:'计提差额',
            align:"center",
            dataIndex: 'peDifference'
          },
          {
            title:'动保费用',
            align:"center",
            dataIndex: 'insuranceFee'
          },
            {
                slotName: 'tableHeader.reviewStatus',
            scopedSlots: { title: 'tableHeader.reviewStatus'},
                align:"center",
                dataIndex: 'approvalStatus_dictText'
            },
            {
                slotName: 'tableHeader.lastApprover',
            scopedSlots: { title: 'tableHeader.lastApprover'},
                align:"center",
                dataIndex: 'lastApprover_dictText'
            },
            {
                slotName: 'tableHeader.lastApprovalTime',
            scopedSlots: { title: 'tableHeader.lastApprovalTime'},
                align:"center",
                dataIndex: 'lastApproveTime',
                customRender:function (text) {
                    return !text?"":(text.length>10?text.substr(0,10):text)
                }
            },
          {
            slotName: 'tableHeader.remarks',
            scopedSlots: { title: 'tableHeader.remarks'},
            align:"center",
            dataIndex: 'notes'
          },
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
          }
        ],
        url: {
          list: "/batchSettlement/efsStlBatchSettlement/list",
          delete: "/batchSettlement/efsStlBatchSettlement/delete",
          deleteBatch: "/batchSettlement/efsStlBatchSettlement/deleteBatch",
          exportXlsUrl: "/batchSettlement/efsStlBatchSettlement/exportXls",
          importExcelUrl: "/batchSettlement/efsStlBatchSettlement/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
        handleFailure(id){
            putAction('/batchSettlement/efsStlBatchSettlement/updateApprovalStatus', {"id": id, "approvalStatus": "40"}).then((res) => {
                if (res.success) {
                    this.$message.success(res.message);
                    this.loadData();
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        handlePass(id){
            putAction('/batchSettlement/efsStlBatchSettlement/updateApprovalStatus', {"id": id, "approvalStatus": "30"}).then((res) => {
                if (res.success) {
                    this.$message.success(res.message);
                    this.loadData();
                } else {
                    this.$message.error(res.message);
                }
            })
        },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>